import CommonStore from "../../../stores/CommonStore";
import {action, makeObservable, observable} from "mobx";
import {SalesService} from "../../../service/SalesService";
import SalesByServiceResponse from "../../../model/sales/SalesByServiceResponse";

class AgencyTotalSalesGraphStore {

    public commonStore: CommonStore;
    public loading: boolean;
    public from?: number;
    public to?: number;
    public agencyId?: string;
    public userId?: string;
    public includeChildren?: boolean;
    public sales?: SalesByServiceResponse

    constructor(
        commonStore: CommonStore,
        from?: number,
        to?: number,
        agencyId?: string,
        userId?: string,
        includeChildren?: boolean
    ) {
        this.commonStore = commonStore;
        this.loading = true;
        this.from = from;
        this.agencyId = agencyId;
        this.userId = userId;
        this.to = to;
        this.includeChildren = includeChildren;
        makeObservable(this, {
            loading: observable,
            from: observable,
            to: observable,
            sales: observable,
            includeChildren: observable,
        });
    }

    @action
    public async getElements(): Promise<void> {
        this.loading = true;
        const response = await SalesService.getSalesByService(this.from, this.to, this.agencyId, this.userId, this.includeChildren);
        if (response.success) {
            this.sales = response.data;
        }
        this.commonStore.processErrors(response);
        this.loading = false;
    }
}

export default AgencyTotalSalesGraphStore;